function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-8.707 14.048) rotate(-90)"
}, React.createElement("path", {
  d: "M6.077,15.851a.5.5,0,0,0,0-.7l-2.3-2.294h9.77a.5.5,0,1,0,0-1H3.793L6.077,9.568a.5.5,0,1,0-.71-.715L2.189,12.037a.45.45,0,0,0,0,.635l3.179,3.179a.5.5,0,0,0,.71,0Z",
  transform: "translate(0 0)",
  fill: "#2c3033"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 7.291,
    height: 11.99,
    viewBox: "0 0 7.291 11.99"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/arrowdownpointer.d97173f0.svg";
export { SvgComponent as ReactComponent };